import {
  FETCH_DEPARTMENTS_LIST,
  FETCH_DEPARTMENT_BY_ID,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  SET_DEPARTMENT_LOADING,
  SET_DEPARTMENT_ERROR,
  CLEAR_DEPARTMENT_ERROR,
  FETCH_SPECIALITIES_LIST
} from "../actions/type";

const initialState = {
  departments: [],
  specialities: [],
  selectedDepartment: null,
  pagination: {
    currentPage: 1,
    pageSize: 10,
    totalRecords: 0,
    totalPages: 0,
    hasNextPage: false,
    hasPreviousPage: false,
    nextPage: null,
    previousPage: null
  },
  loading: false,
  error: null
};

const departmentManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENTS_LIST:
      return {
        ...state,
        departments: action.payload.departments || [],
        pagination: action.payload.pagination || state.pagination,
        error: null
      };

    case FETCH_SPECIALITIES_LIST:
      return {
        ...state,
        specialities: action.payload || [],
        error: null
      };

    case FETCH_DEPARTMENT_BY_ID:
      return {
        ...state,
        selectedDepartment: action.payload,
        error: null
      };

    case ADD_DEPARTMENT:
      return {
        ...state,
        error: null
      };

    case UPDATE_DEPARTMENT:
      return {
        ...state,
        selectedDepartment: null,
        error: null
      };

    case DELETE_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.filter(dept => dept.ssm_id !== action.payload),
        error: null
      };

    case SET_DEPARTMENT_LOADING:
      return {
        ...state,
        loading: action.payload
      };

    case SET_DEPARTMENT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false
      };

    case CLEAR_DEPARTMENT_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};

export default departmentManagementReducer;
